import { gql } from "@apollo/client";

export const ME_QUERY = gql(`
    query Me {
      me {
        id
        phone
        email
        createdAt
        updatedAt
        referralCode
        name
      }
    }
  `);
